const src = import.meta.ROLLUP_FILE_URL_uyxRyhxw$2I5bBOwG10uUA;
export default {
  src,
  srcSet: src + " " + 648 + "w",
  width: 648,
  height: 960,
};